/**
 * I18n Provider
 *
 * Provider for internationalization functionality
 * Initializes i18n and manages language state
 */

import { PropsWithChildren, ReactElement } from 'react';
import { useUserLanguage } from '@/hooks/useUserLanguage';

// I18n provider props
interface I18nProviderProps extends PropsWithChildren {
  // Allow disabling for testing
  enableI18n?: boolean;
}

/**
 * I18n Provider Component
 *
 * Initializes internationalization and manages language state
 * Works with or without authentication context
 */
export function I18nProvider({ children }: I18nProviderProps): ReactElement {
  // Initialize user language management without requiring auth context
  // The hook will handle auth context availability internally
  useUserLanguage();

  return <>{children}</>;
}

// Convenience exports for testing
export const TestI18nProvider = ({ children }: PropsWithChildren): ReactElement => (
  <I18nProvider enableI18n={false}>{children}</I18nProvider>
);
